import { useNavigate } from "@tanstack/react-router"
import { useState } from "react"

import { Page } from "@/routes/auth/Page.tsx"
import { Navigator } from "@/routes/Navigator.ts"
import { useCurrentOrgId } from "@/routes/projects/projectHooks.ts"
import { UserSettingsDialog } from "@/routes/user/UserSettingsDialog.tsx"

export const UserSettingsDialogOpener = () => {
  const orgId = useCurrentOrgId()
  const navigate = useNavigate()

  const [dialogOpen, setDialogOpen] = useState(true)

  const handleDialogClose = (open: boolean) => {
    setDialogOpen(open)
    if (!open) {
      void navigate(Navigator.orgHome(orgId))
    }
  }

  return (
    <Page>
      <UserSettingsDialog dialogOpen={dialogOpen} setDialogOpen={handleDialogClose} />
    </Page>
  )
}
